import React from 'react';
import { createBrowserRouter, RouterProvider, createMemoryRouter, Navigate } from 'react-router-dom';
import features from './config/features.js';
import Layout from './components/layout/Layout.js';
import UsersList from './components/users/UsersList.js';
import TemplateList from './components/templates/TemplateList.js';
import SpecialTemplatesList from './components/templates/SpecialTemplatesList.js';
import SpecialRulesList from './components/specialRules/SpecialRulesList.js';
import KeyWordsList from './components/keyWords/KeyWordsList.js';
import Profile from './components/Profile.js';
import WorkplacesUsers from './components/workplacesUsers/WorkplacesUsersList.js';
import SchedulerTasks from './components/schedulerTasks/SchedulerTasksList.js';
import DataUploader from './components/dataUploader/DataUploader.js';
import Dashboard from './components/dashboard/Dashboard.js';
import GeneralSettings from './components/generalSettings/GeneralSettings.js';

const App = ({ isTest = false }) => {
  const baseRoutes = [
    {
      path: "/",
      element: <Layout />,
      children: [
        { path: "/", element: <Dashboard /> },
        { path: "/userslist", element: <UsersList /> },
        { path: "/templateslist", element: <TemplateList /> },
        { path: "/keywords", element: <KeyWordsList /> },
        { path: "/workplacesusers", element: <WorkplacesUsers /> },
        { path: "/profile", element: <Profile /> },
        { path: "/schedulertasks", element: <SchedulerTasks /> },
        { path: "/loaddata", element: <DataUploader /> },
        { path: "/dashboard", element: <Dashboard /> },
        { path: "/general-settings", element: <GeneralSettings /> },
        { path: "*", element: <div>404 - Página no encontrada</div> }
      ]
    }
  ];

  // Agregar ruta condicional según el flag
  const layoutRoute = baseRoutes[0];

  if (features.specialTemplatesEnabled) {
    // Flag activo: ruta funciona normalmente y Special Templates se muestra en el sidebar
    layoutRoute.children.splice(layoutRoute.children.length - 1, 0, {
      path: "/special-templates",
      element: <SpecialTemplatesList />
    });
  } else {
    // Flag desactivado: redirigir a home
    layoutRoute.children.splice(layoutRoute.children.length - 1, 0, {
      path: "/special-templates",
      element: <Navigate to="/" replace />
    });
  }

  if (features.specialRulesEnabled) {
    layoutRoute.children.splice(layoutRoute.children.length - 1, 0, {
      path: "/special-rules",
      element: <SpecialRulesList />
    });
  } else {
    layoutRoute.children.splice(layoutRoute.children.length - 1, 0, {
      path: "/special-rules",
      element: <Navigate to="/" replace />
    });
  }

  const routes = baseRoutes;

  const routerOptions = {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }
  };

  // Usar createMemoryRouter para pruebas
  const router = isTest
    ? createMemoryRouter(routes, routerOptions)
    : createBrowserRouter(routes, routerOptions);

  return <RouterProvider router={router} />;
};

export default App;